import {z} from 'zod';
import {ObjectIdSchema} from './zod';
import {UIMessage} from 'ai';

export const MinCampaignsTestListSize = 30;

export const CampaignSchema = z.object({
  name: z.string(),
  target: z.string(),
  examples: z.array(z.string()),
  brief: z.string(),
});
export type Campaign = z.infer<typeof CampaignSchema>;

export const CampaignChatSchema = z.object({
  customerId: ObjectIdSchema,
  name: z.string(),
  messages: z.unknown().array(), // https://github.com/vercel/ai/issues/6763
  campaigns: CampaignSchema.array(),
  lastResponseId: z.string(),
  createdAt: z.date(),
});
export type CampaignChat = z.infer<typeof CampaignChatSchema> & {
  // Override the type of messages until a zod schema is available for it.
  messages: UIMessage[];
};
